var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEducationPurple = function SvgEducationPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 17.65c.52-.227 1.021-.492 1.5-.794V20.5a.75.75 0 1 1-1.5 0v-2.85ZM11.338 6.646a.748.748 0 0 0 .31 1.015L16.03 10l1.594-.85-5.272-2.812a.75.75 0 0 0-1.015.309Zm12.265-.309-11.25-6a.75.75 0 0 0-.706 0l-11.25 6a.75.75 0 0 0 0 1.324L2.625 8.85v4.661c0 .325.105.64.3.9.742.988 3.592 4.214 9.075 4.214a12.065 12.065 0 0 0 4.875-.98V10.45l-.844-.45L12 12.15 3.735 7.742l-.006-.003L2.344 7 12 1.85 21.656 7l-1.385.739-.006.003-2.64 1.408.353.188a.76.76 0 0 1 .397.662v6.85a10.353 10.353 0 0 0 2.7-2.44c.195-.259.3-.574.3-.899V8.85l2.228-1.188a.75.75 0 0 0 0-1.324Z",
    fill: "#7160C5"
  })));
};

export default SvgEducationPurple;